import { Action, createReducer, on } from '@ngrx/store';

import { DynamicComponent } from '@priva/components/dynamic';
import { NotificationStatus } from '@priva/notifications';

import { AppActions } from '.';
import { AppState, initialAppState } from './app.state';

const appReducer = createReducer(
    initialAppState,

    on(AppActions.openDialog, (state, { dialog }) => {
        let activeDialogs: DynamicComponent[];
        if (state.activeDialogs) {
            activeDialogs = [
                ...state.activeDialogs.filter((d: DynamicComponent) => d.component !== dialog.component),
                dialog,
            ];
        } else {
            activeDialogs = [dialog];
        }
        return { ...state, activeDialogs };
    }),
    on(AppActions.closeDialog, (state) => {
        let activeDialogs: DynamicComponent[] = [];
        if (state.activeDialogs) {
            activeDialogs = [...state.activeDialogs];
            activeDialogs.pop();
        }
        return { ...state, activeDialogs };
    }),
    on(AppActions.showErrorNotification, (state, { notification }) => {
        return {
            ...state,
            notification: {
                message: notification,
                status: NotificationStatus.Danger,
            },
        };
    }),
    on(AppActions.showWarningNotification, (state, { notification }) => {
        return {
            ...state,
            notification: {
                message: notification,
                status: NotificationStatus.Warning,
            },
        };
    }),
    on(AppActions.showSuccessNotification, (state, { notification }) => {
        return {
            ...state,
            notification: {
                message: notification,
                status: NotificationStatus.Success,
            },
        };
    }),
    on(AppActions.showInfoNotification, (state, { notification }) => {
        return {
            ...state,
            notification: {
                message: notification,
                status: NotificationStatus.Info,
            },
        };
    }),
    on(AppActions.removeNotification, (state) => {
        return {
            ...state,
            notification: undefined,
        };
    }),
);

export function reducer(state: AppState | undefined, action: Action): AppState {
    return appReducer(state, action);
}
